<template>
<div
    v-if="value != null && lightboxes != null"
>
    <v-card
        style="margin-bottom: 15px;"
    >
        <v-card-title>Lightbox URL ({{index+1}})</v-card-title>

        <v-card-text>
                <m-edit-select
                    label="Domain Name"
                    :value="getDomainObject(value.url_matcher.domain)"
                    :possible_values="domains"
                    v-on:input="setDomain($event,index)"
                />

                <m-edit-text
                    label="Path"
                    :value="value.url_matcher.path_matcher.pattern"
                    v-on:input="setPathMatcher($event,index)"
                    hint="Use * as a wildcard (will match any string), use {index-page} to match the home page only, use {empty-path} to match only the empty path, use not: to invert the matching (you can seperate multiple paths using spaces)"
                />

                <m-edit-select
                    label="Lightbox"
                    :value="getLightboxObject(value.lightbox_id)"
                    :possible_values="lightbox_choices"
                    v-on:input="setLightbox($event)"
                />

                <m-edit-text
                    label="Display Delay (sec)"
                    :value="value.display_delay_ms / 1000"
                    v-on:input="setDisplayDelay($event)"
                    hint="Display delay in seconds (you can use decimals for fractional sections, e.g. 4.5 for four and a half seconds)"
                />

                <div
                    style="position: absolute; right: 20px; top: 20px;"
                >
                    <v-menu 
                        bottom 
                        offset-y  
                    >

                        <template v-slot:activator="{ on }">
                            
                            <v-icon
                                v-on="on"
                                color="primary"
                            >
                                mdi-dots-vertical
                            </v-icon>
                            
                        </template>

                        <v-list>
                            <v-list-item
                                v-on:click="moveUp()"
                            >
                                <v-list-item-title>Move Up</v-list-item-title>
                            </v-list-item>

                            <v-list-item
                                v-on:click="moveDown()"
                            >
                                <v-list-item-title>Move Down</v-list-item-title>
                            </v-list-item>

                            <v-divider/>

                            <v-list-item
                                v-on:click="newURLBefore()"
                            >
                                <v-list-item-title>New URL before...</v-list-item-title>
                            </v-list-item>

                            <v-list-item
                                v-on:click="newURLAfter()"
                            >
                                <v-list-item-title>New URL after...</v-list-item-title>
                            </v-list-item>

                            <v-divider/>

                            <v-list-item
                                v-on:click="deleteURL()"
                            >
                                <v-list-item-title>Delete...</v-list-item-title>
                            </v-list-item>


                        </v-list>

                    </v-menu>


                </div>

        </v-card-text>

    </v-card>
</div>
</template>

<script>
const _ = require('lodash');

export default {
    props: {
        value: {
            type: Object,
            default: function() { return null; }
        },

        index: {
            type: Number,
            default: function() { return 0; }
        },

        lightboxes: {
            type: Object,
            default: function() { return null; }
        },
    },
    
    data() {
        return {
            getDomainObject(domain_value)
            {
                let domains = this.domains;
                for ( let i = 0; i < domains.length; i++ )
                {
                    if ( domains[i].domain == domain_value )
                        return domains[i];
                }
                return { 'text' : 'Any domain', 'domain' : '*' };
            },

            setDomain(domain_obj, index)
            {
                let new_value = _.cloneDeep(this.value);
                new_value.url_matcher.domain = domain_obj.domain;
                this.$emit('input', new_value);
            },

            setPathMatcher(new_path_matcher)
            {
                let new_value = _.cloneDeep(this.value);
                new_value.url_matcher.path_matcher.pattern = new_path_matcher;
                this.$emit('input', new_value);
            },

            getLightboxObject(id)
            {
                return this.lightbox_choices.find(item => item.value == id);
            },

            setLightbox(id)
            {
                let new_value = _.cloneDeep(this.value);
                new_value.lightbox_id = id.value;
                this.$emit('input', new_value);
            },

            moveUp()
            {
                this.$emit('move-up', this.value);
            },

            moveDown()
            {
                this.$emit('move-down', this.value);
            },

            deleteURL()
            {
                this.$rc.confirm({
                    'title': 'Delete Url',
                    'body': 'Are you sure that you would like to delete this url? This can not be undone.',
                    'btn_text_ok': 'Delete',
                    'btn_text_cancel': 'Cancel',
                    'on_ok': () => {
                        this.$emit('delete', this.value);
                    },
                });
            },

            newURLBefore()
            {
                this.$emit('create-new', {'above_url_id': this.value.url_id});
            },  

            newURLAfter()
            {
                this.$emit('create-new', {'below_url_id': this.value.url_id});
            }, 

            setDisplayDelay(value)
            {
                if ( value == null )
                    return;

                let new_delay = parseFloat(value);

                if ( Number.isNaN(new_delay) || new_delay < 0 )
                {
                    alert('You did not enter a valid delay -- no change has been made');
                    return;
                }

                let new_value = _.cloneDeep(this.value);
                new_value.display_delay_ms = new_delay * 1000;
                this.$emit('input', new_value);
            },
        }
    },

    computed: {
        domains() {
            let ret = [
                { 'text' : 'Any domain', 'domain' : '*' },
            ];

            if ( this.lightboxes != null )
            {
               for ( let i = 0; i < this.lightboxes.owned_domains.length; i++ )
                {
                    ret.push(
                        { 'text' : this.lightboxes.owned_domains[i].domain, 'domain' : this.lightboxes.owned_domains[i].domain }
                    );
                }
            }

            return ret;
        },

        lightbox_choices()
        {
            let ret = [];

            if ( this.lightboxes != null )
            {
                ret = this.lightboxes.settings
                    .map(item => { return { 'text': item.label, 'value': item.lightbox_id} });
            }

            return ret;
        },
    },
}
</script>

<style lang="scss" scoped>

</style>